import { render, staticRenderFns } from "./QuoteTest.vue?vue&type=template&id=06fb15be&scoped=true&"
import script from "./QuoteTest.vue?vue&type=script&lang=js&"
export * from "./QuoteTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb15be",
  null
  
)

export default component.exports